import { render } from "./BrContact.vue?vue&type=template&id=4bd74ced&scoped=true"
import script from "./BrContact.vue?vue&type=script&lang=js"
export * from "./BrContact.vue?vue&type=script&lang=js"

import "./BrContact.vue?vue&type=style&index=0&id=4bd74ced&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd74ced"]])

export default __exports__